import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { ApplicationConfig } from '@angular/platform-browser';
import { Routes, provideRouter } from '@angular/router';

import { ENVIRONMENT } from '@sondermind/utilities/models-environment';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { ConfigurationModule } from '@sondermind/configuration';
import { LAUNCH_DARKLY_SERVICE, LaunchDarklyService } from '@sondermind/launch-darkly';
import { LoggingInitModule } from '@sondermind/logging-init';
import { WINDOW } from '@sondermind/utilities/tools';

import { AUTH_SERVICE } from '@sondermind/utilities/models-auth';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '**', component: AppComponent }
];

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    importProvidersFrom(ConfigurationModule),
    importProvidersFrom(DatadogLoggingModule.forRoot(environment)),
    importProvidersFrom(LoggingInitModule),
    provideRouter(routes),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: LAUNCH_DARKLY_SERVICE, useClass: LaunchDarklyService },
    { provide: WINDOW, useValue: window },
    { provide: AUTH_SERVICE, useValue: { getAuthToken: () => '' } },
  ],
};
